<app-screen-content [isLoading]="model.isLoading">
  <ng-container title>
    <img src="assets/icons/ic-assessment@3x.svg" alt="" />
    <span>Risk profile assessment</span>
  </ng-container>

  <div body>
    <form [formGroup]="form" (ngSubmit)="model.onSubmit()">
      <section class="box">
        <div class="row row-assessed-profile">
          <div class="col-lg-4 data-group">
            <app-data-point
              *ngIf="model.assessedRiskProfile"
              [emphasized]="true"
            >
              <span label>Your assessed profile</span>
              <div value>
                {{ model.assessedRiskProfile }}
              </div>
            </app-data-point>
          </div>
          <div class="col-lg-4 data-group">
            <app-data-point
              *ngIf="model.declaredRiskProfile"
              [emphasized]="true"
            >
              <span label>Your declared profile</span>
              <div value>
                {{ model.declaredRiskProfile }}
              </div>
            </app-data-point>
          </div>
        </div>
        <app-alert *ngIf="declaredNotEqualAssessed" class="alert-wrapper">
          <div>
            The result of our assessment is different from your organisation’s
            view of its risk profile.
          </div>
          <div>
            This will affect the products we will be recommending to you
          </div>
          <div
            class="blue-link product-link"
            (click)="showRecommendedProduct()"
          >
            View products recommended for your risk profile
          </div>
        </app-alert>
      </section>

      <section class="box" *ngIf="declaredNotEqualAssessed">
        <div class="question-title">
          Do you wish to accept the risk profile assessment?
        </div>
        <div class="row row-accept-assessed-risk">
          <div class="col-lg-6">
            <app-radio
              name="isAcceptAssessedRiskProfile"
              formControlName="isAcceptAssessedRiskProfile"
              label="Yes"
              description="We accept OCBC's risk assessment"
              [radioValue]="true"
              [value]="isAcceptAssessedRiskProfileControl.value"
              (click)="isAcceptAssessRiskProfileOptionClick($event, true)"
            ></app-radio>
          </div>
          <div class="col-lg-6">
            <app-radio
              name="isAcceptAssessedRiskProfile"
              formControlName="isAcceptAssessedRiskProfile"
              label="No"
              description="We do not accept OCBC's assessment and would like to maintain our declared risk profile"
              [radioValue]="false"
              [value]="isAcceptAssessedRiskProfileControl.value"
              (click)="isAcceptAssessRiskProfileOptionClick($event, false)"
            ></app-radio>
          </div>
        </div>
      </section>

      <div class="bottom-nav">
        <app-back-button (click)="goToPreviousScreen()"></app-back-button>
        <app-next-button
          buttonType="submit"
          [disabled]="!form.valid"
        ></app-next-button>
      </div>
    </form>

    <ng-template #confirmationModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Attention</h4>
      </div>
      <div class="modal-body">
        Your current inputs will be cleared. Would you like to continue?
      </div>
      <div class="modal-footer">
        <app-primary-button
          buttonType="button"
          [outline]="true"
          (click)="modal.dismiss()"
        >
          No
        </app-primary-button>
        <app-primary-button buttonType="button" (click)="modal.close('save')">
          Yes
        </app-primary-button>
      </div>
    </ng-template>

    <div *ngIf="globals.isDebug">
      <h3>Information for developers, please ignore</h3>

      <h4>Data</h4>
      <pre class="debug-log-mono">{{ model.data | json }}</pre>
      <h4>Model</h4>
      <h5>Form value</h5>
      <pre class="debug-log-mono">{{ form.value | json }}</pre>
    </div>
  </div>
</app-screen-content>
